<template>
    <DialogLayout>
        <h3 class="ModalAccount__title">Créer votre compte</h3>
        <form class="FormMaterial ModalAccount__form" @submit.prevent="handleSubmit">
            <InputMaterial @input="value => handleChange('email', value)"
                           label="Adresse e-mail" v-model="data.email" type="email" :error="errors.email"/>
            <div class="row">
                <div class="col-md-6">
                    <InputMaterial @input="value => handleChange('password', value)"
                                   label="Mot de passe" v-model="data.password" type="password"
                                   :error="errors.password"/>
                </div>
                <div class="col-md-6">
                    <InputMaterial @input="value => handleChange('passwordConfirmation', value)"
                                   label="Confirmation" v-model="data.passwordConfirmation"
                                   type="password" :error="errors.passwordConfirmation"/>
                </div>
            </div>
            <div class="ModalAccount__type">
                <span class="ModalAccount__type-label">Vous êtes ?</span>
                <div class="Radio">
                    <input class="Radio__input" type="radio" @input="value => handleChange('type', value)"
                           v-model="data.type" name="type"
                           :value="$enums.UserType.COMPANY"
                           id="company-type"/>
                    <label class="Radio__label" for="company-type">Une entreprise</label>
                </div>
                <div class="Radio">
                    <input class="Radio__input" type="radio" @input="value => handleChange('type', value)"
                           v-model="data.type" name="type"
                           :value="$enums.UserType.LEARNER"
                           id="learner-type"/>
                    <label class="Radio__label" for="learner-type">Un apprenant</label>
                </div>
                <span class="ModalAccount__type-error form-error" v-if="errors.type">{{ errors.type[0] }}</span>
            </div>
            <div class="text-center">
                <button type="submit" :disabled="loading" class="Btn Btn--primary Btn--gradient Btn--shadow">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>S'inscrire <i class="fas fa-caret-right m-l-5"></i></span>
                </button>
                <button v-if="isMobile" type="button" @click.prevent="$emit('changeTab', 'login')"
                        class="ModalAccount__switch">
                    J'ai déjà un compte
                </button>
            </div>
            <p class="ModalAccount__text">
                En cliquant sur le bouton &laquo; S'inscrire &raquo;, vous acceptez nos
                <a href="/cgu" target="_blank">conditions d'utilisation</a>.
            </p>
        </form>
    </DialogLayout>
</template>

<script>
    import validate from "../../../validator/validator";
    import * as Rules from "../../../validator/rules";
    import {isEmpty} from "../../../utils";
    import Api from "../../../services/Api";
    import DialogLayout from "../Layouts/DialogLayout";
    import InputMaterial from "../../InputMaterial";
    import ModalBus from "../../../eventBus";

    export default {
        components: {InputMaterial, DialogLayout},
        props: ['isMobile'],
        data: function () {
            return {
                data: {
                    type: null,
                    email: null,
                    password: null,
                    passwordConfirmation: null
                },
                loading: false,
                errors: {}
            }
        },
        methods: {
            handleChange: function (name) {
                delete this.errors[name];
            },
            handleSubmit: async function () {
                this.loading = true;
                try {
                    let {type, email, password} = this.data,
                        errors = validate(this.data, {
                            type: [Rules.oneOf(Object.values(this.$enums.UserType))],
                            email: [Rules.required(), Rules.email()],
                            password: [Rules.required(), Rules.minLength(6)],
                            passwordConfirmation: [Rules.same('password', 'Les mots de passes ne sont pas identiques.')]
                        });

                    if (!isEmpty(errors)) {
                        this.errors = errors;
                        this.loading = false;
                        return;
                    }

                    let data = {
                        type,
                        email,
                        password
                    };

                    await this.$recaptchaLoaded();
                    data['g-recaptcha-response'] = await this.$recaptcha('signup');

                    await Api.post('/auth/signup', data);

                    ModalBus.alertSuccess(
                        'Inscription validé !',
                        'Afin de vérifier votre compte, un email contenant un lien de vérification vous a été envoyé. Pensez à vérifier vos spams.'
                    );
                } catch (err) {
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                        this.loading = false;
                    } else {
                        ModalBus.processingError();
                    }
                }

                this.loading = false;
            }
        }
    }
</script>
